import React from "react";
import '../../MatchCard.scss'


const DetailsOfMathc = ({status, homeImg, homeTitle,awayImg,awayTitle,vs})=>{
    const showDetailsOfMatch = ()=>{
        if(status.scheduleStatus === 'COMPLETED'){
            return '' }

        return (
            <div className="matchCard_contenedor" style={{display:'flex', justifyContent:'center'}}>

    <div className="contenedor-banderas" >
    <div style={{display:'flex', justifyContent:'space-between'}}>
        <div className="contenedores-de-una-bandera">
            <img className={homeImg?.classHolder ? "placeholderSize" : "banderasSize"}  src={homeImg?.classHolder ? homeImg.placeholder : homeImg } />
            <div><h2 className="titleSize" >{homeTitle}</h2></div>
        </div>
        <div className="conteiner-vs"  >
        <h2 className="vsTitle">{vs}</h2>

        </div>
        <div className="contenedores-de-una-bandera">
        <img className={awayImg?.classHolder ? "placeholderSize" : "banderasSize"}  src={awayImg?.classHolder ? awayImg.placeholder : awayImg } />
        <div><h2 className="titleSize">{awayTitle}</h2></div>

        </div>

    </div>
    </div>
    </div>

        )

    }

    return (
        <>
        {showDetailsOfMatch()}
        </>
    )
}

export default DetailsOfMathc